import { Navigate } from 'react-router-dom';
import { history } from '../helpers';

export { PrivateRoute };

function PrivateRoute({ children }) {
    const authUser = localStorage.getItem('customer-portal');
    if (!authUser) {
        // not logged in so redirect to login page with the return url
        return <Navigate to="/" state={{ from: history.location }} />
    }

    // authorized so return child components
    return children;
}